const RECORDED_KPI_SOURCES = new Set(['manual', 'hub', 'zoho']);

/**
 * Whether a KPI row has a live or logged value (manual, Hub, or Zoho).
 * @param {object} [item]
 */
export function kpiHasRecordedValue(item) {
    if (!item) return false;
    if (!RECORDED_KPI_SOURCES.has(item.source)) return false;
    return Number.isFinite(Number(item.value));
}

/**
 * Progress toward target, capped at 100. Empty rows count as 0.
 * @param {object} [item]
 * @returns {number}
 */
export function kpiCompletionPercent(item) {
    if (!kpiHasRecordedValue(item)) return 0;
    const target = Number(item.target);
    if (!Number.isFinite(target) || target === 0) return 0;
    return Math.min((Number(item.value) / target) * 100, 100);
}

/**
 * Mean completion across KPI rows, rounded to a whole percent.
 * @param {object[]} [items]
 * @returns {number}
 */
export function averageKpiCompletionPercent(items) {
    if (!Array.isArray(items) || items.length === 0) return 0;
    const sum = items.reduce(
        (acc, item) => acc + kpiCompletionPercent(item),
        0
    );
    return Math.round(sum / items.length);
}

/**
 * @param {object} [item]
 * @returns {string}
 */
export function formatKpiValue(item) {
    if (!kpiHasRecordedValue(item)) return '—';
    const n = Number(item.value);
    if (Number.isInteger(n)) return String(n);
    return n.toFixed(1);
}
